
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sites/[slug]/[locale]/[p]",
      function () {
        return require("private-next-pages/sites/[slug]/[locale]/[p].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sites/[slug]/[locale]/[p]"])
      });
    }
  